import { Component, Input } from '@angular/core';
import { InputWrapperComponent } from "../input-wrapper/input-wrapper.component";
import { popInOut } from '../../animations';

@Component({
  selector: 'psc-input',
  templateUrl: './text-input.component.html',
  animations: [popInOut],
})
export class TextInputComponent extends InputWrapperComponent<string>{

  @Input() type: 'text' | 'password' | 'textarea' | 'email' | 'tel' | 'url' | 'search' | 'number' = 'text';
  @Input() placeholder: string;
  @Input() readonly = false;
  @Input() format: string;
  @Input() prefix: string;
  @Input() prefixIcon: string;
  @Input() name: string;

  showPassword: boolean = false;
}
